<template>
  <div>
    <div class="double-box">
      <ag-multiselect
        :options="[
          { label: 'Site and Group', code: 'siteAndGroup' },
          { label: 'Computer Name', code: 'computerName' },
          { label: 'User Name', code: 'userName' },
          { label: 'Operating System', code: 'operatingSystem' },
          { label: 'Agent Version', code: 'agentVersion' },
          { label: 'Computer Name', code: 'computerName' },
          { label: 'Policy Version', code: 'policyVersion' }
        ]"
        :reduce-display-property="(option) => option.label"
        :reduce-value-property="(option) => option.code"
      ></ag-multiselect>
    </div>
  </div>
</template>

<script>
import AgMultiselect from "@/components/ag-multiselect/index.vue";
export default {
  name: "Customize",
  components: { AgMultiselect },
  data: () => ({
    selected: [],
  }),
};
</script>

<style scoped lang="scss">
.double-box {
  display: flex;
  justify-content: center;
  margin: 3rem 0;
}
</style>
